import React, { useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/PaymentHistoryFilterDialog.css";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";

interface PaymentHistoryFilterDialogProps {
  open: boolean;
  onClose: () => void;
  onApply: (filterValue: string) => void;
}

const PaymentHistoryFilterDialog: React.FC<PaymentHistoryFilterDialogProps> = ({
  open,
  onClose,
  onApply,
}) => {
  const [paymentMode, setPaymentMode] = useState("all");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "payment-history-filter-dialog-container",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div>
          <div className="payment-history-filter-header-container">
            <div className="payment-history-filter-header-text-container">
              <div className="payment-history-filter-header-container-text">
                Filter by
              </div>
            </div>

            <div className="payment-history-filter-header-container-divider"></div>
            <div className="payment-history-filter-header-button-container">
              <div
                className="payment-history-filter-header-container-button"
                onClick={onClose}
              >
                ✕
              </div>
            </div>
          </div>
          <div className="payment-history-filter-divider"></div>
          <div className="payment-history-filter-dialog-content">
            <span>
              Payment <span style={{ color: "#FF6B35" }}>Mode</span>
            </span>
            <select
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
            >
              <option value="all">All</option>
              <option value="credit">via Membership Credit</option>
              <option value="payment">via Digital Payment</option>
            </select>

            <button
              className="payment-history-filter-dialog-content-button"
              onClick={() => {
                onApply(paymentMode);
                onClose();
              }}
            >
              Apply
              <img src={letsDoItIcon} alt="lets-do-it-logo" />
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentHistoryFilterDialog;
